import React from "react";
import { Link, useNavigate } from "react-router-dom";
import ContinentsBg from "../assets/img/continents.jpg";

function Continents() {
    const navigate = useNavigate();
    
  const countries = {
    Europe: [
      { name: "United Kingdom", url: "/destination/uk" },
      { name: "Italy", url: "/destination/italy" },
      { name: "Ireland", url: "/destination/ireland" },
      { name: "Germany", url: "/application" },
      { name: "France", url: "/application" },
      { name: "Spain", url: "/application" },
      { name: "Netherlands", url: "/application" },
      { name: "Belgium", url: "/application" },
      { name: "Sweden", url: "/application" },
      { name: "Poland", url: "/application" },
      { name: "Norway", url: "/application" },
    ],
    "North America": [
      { name: "United States", url: "/destination/us" },
      { name: "Canada", url: "/destination/canada" },
      { name: "Mexico", url: "/application" },
      { name: "Cuba", url: "/application" },
      { name: "Jamaica", url: "/application" },
      { name: "Panama", url: "/application" },
      { name: "Honduras", url: "/application" },
      { name: "Guatemala", url: "/application" },
      { name: "Costa Rica", url: "/application" },
      { name: "Dominican Republic", url: "/application" },
    ],
    Asia: [
      { name: "Dubai", url: "/destination/dubai" },
      { name: "China", url: "/application" },
      { name: "India", url: "/application" },
      { name: "Japan", url: "/application" },
      { name: "South Korea", url: "/application" },
      { name: "Vietnam", url: "/application" },
      { name: "Thailand", url: "/application" },
      { name: "Indonesia", url: "/application" },
      { name: "Malaysia", url: "/application" },
      { name: "Philippines", url: "/application" },
      { name: "Singapore", url: "/application" },
    ],
    Africa: [
      { name: "South Africa", url: "/application" },
      { name: "Egypt", url: "/application" },
      { name: "Nigeria", url: "/application" },
      { name: "Kenya", url: "/application" },
      { name: "Ghana", url: "/application" },
      { name: "Morocco", url: "/application" },
      { name: "Algeria", url: "/application" },
      { name: "Ethiopia", url: "/application" },
      { name: "Tanzania", url: "/application" },
      { name: "Uganda", url: "/application" },
    ],
  };

  return (
    <div className="container mx-auto">
      <div className="block bg-white h-[130px]"></div>
      <div className="container mx-auto">
        <div className="relative w-full h-[200px] md:h-[280px] overflow-hidden group rounded-3xl">
          <img
            src={ContinentsBg}
            alt="Background"
            className="w-full h-full object-cover rounded-3xl transition-transform duration-500 group-hover:scale-110"
          />

          <div className="absolute inset-0 flex bg-black bg-opacity-55 items-center justify-center">
            <h1 className="text-white text-3xl md:text-6xl font-bold text-center">
              Continents
            </h1>
          </div>
        </div>

        <div className="container mx-auto p-8">
          {/* <h1 className="text-3xl font-bold text-center mb-8">
            Countries by Continent
          </h1> */}
           <button
                onClick={() => navigate(-1)}
                className="text-primary rounded-full gap-2 px-8 py-2 border border-gray-300 hover:bg-gray-50 transition-colors"
              >
                Go Back
              </button>

          <table className="table-auto w-full border-collapse border mt-12 border-gray-300">
            <thead>
              <tr className="bg-gray-neutral text-gray-cool uppercase">
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Continent
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Countries
                </th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(countries).map(([continent, countryList]) => (
                <tr key={continent}>
                  <td className="border border-b-0 border-x-0 text-primary flex items-start justify-start border-gray-300 px-4 py-2 font-bold">
                    {continent}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    <ul className="list-none list-inside">
                      {countryList.map((country) => (
                        <li
                          key={country}
                          className="text-primary hover:underline"
                        >
                          <Link to={country.url}>{country.name}</Link>
                        </li>
                      ))}
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Continents;
